/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_ConnectedInputs */

const en_dropbox_connected = /** @type {(inputs: Dropbox_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox is connected. You can now browse and import files.`)
};

const es_dropbox_connected = /** @type {(inputs: Dropbox_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox está conectado. Ya puedes explorar e importar archivos.`)
};

/**
* | output |
* | --- |
* | "Dropbox is connected. You can now browse and import files." |
*
* @param {Dropbox_ConnectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_connected = /** @type {((inputs?: Dropbox_ConnectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_ConnectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_connected(inputs)
	return en_dropbox_connected(inputs)
});